import { useState } from "react";
import { forumPosts, communityVoices } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const boards = ["全部", "新手互助", "晒物专区", "拼装交流", "手办情报", "交易区"];

const boardStats = [
  { name: "新手互助", count: "8.2万帖" },
  { name: "晒物专区", count: "12.6万帖" },
  { name: "拼装交流", count: "9.4万帖" },
  { name: "手办情报", count: "6.1万帖" },
  { name: "交易区", count: "4.7万帖" },
];

export default function Forum() {
  const [active, setActive] = useState("全部");

  const list = forumPosts.filter((post) => active === "全部" || post.board === active);

  return (
    <section id="forum" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="论坛讨论"
          title="晒物、求推荐、聊避坑，同好都在这里"
          desc="按板块分区，想聊什么进什么。热帖自动置顶，冷门问题也有人接。"
          actionLabel="发布新帖"
          actionHref="#forum"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="mb-5 flex flex-wrap gap-2">
              {boards.map((board) => (
                <button
                  key={board}
                  type="button"
                  onClick={() => setActive(board)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
                    active === board
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  {board}
                </button>
              ))}
            </div>

            <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
              {list.map((post) => (
                <li key={post.id}>
                  <a href="#forum" className="block p-5 transition-colors hover:bg-background-100">
                    <div className="flex items-start gap-3">
                      {post.hot && (
                        <span className="mt-0.5 flex h-5 shrink-0 items-center rounded bg-primary-100 px-1.5 text-[11px] font-medium text-primary-800">
                          热
                        </span>
                      )}
                      <div className="min-w-0 flex-1">
                        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                          {post.title}
                        </h3>
                        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                          {post.excerpt}
                        </p>
                        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                            {post.board}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-user-line" />
                            {post.author}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line" />
                            {post.replies} 回复
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" />
                            {post.time}
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>

            {list.length === 0 && (
              <p className="rounded-lg border border-background-200 bg-background-50 p-8 text-center text-sm text-foreground-500">
                该板块暂无热帖，去发一帖开个头吧。
              </p>
            )}
          </div>

          <aside className="space-y-4 lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-layout-grid-line text-primary-600" />
                板块导航
              </h3>
              <ul className="mt-4 space-y-1">
                {boardStats.map((board) => (
                  <li key={board.name}>
                    <button
                      type="button"
                      onClick={() => setActive(board.name)}
                      className="flex w-full cursor-pointer items-center justify-between rounded-md px-2 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-50"
                    >
                      <span className="flex items-center gap-2">
                        <i className="ri-hashtag text-foreground-400" />
                        {board.name}
                      </span>
                      <span className="text-xs text-foreground-500">{board.count}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-600" />
                今日活跃同好
              </h3>
              <ul className="mt-4 space-y-4">
                {communityVoices.map((voice) => (
                  <li key={voice.id} className="flex gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {voice.name.slice(0, 1)}
                    </span>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-foreground-900">{voice.name}</span>
                        <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[10px] text-accent-800">
                          {voice.tag}
                        </span>
                      </div>
                      <p className="mt-0.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                        {voice.text}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}